import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { green } from '@material-ui/core/colors';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS_API } from 'src/app/constant/config';

import { Formik } from 'formik';
import { vehicleType } from 'src/app/constant/vehicleType';
import { getListAgencies } from 'src/features/agencySlice';
import {
  activeDevice,
  getUsernameByPhoneNumber,
  resetSearchUsernameByPhone,
  transmitActiveStatus
} from 'src/features/deviceSlice';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';
import Switch from '@material-ui/core/Switch';
import { getBusinessInfo, resetBusinessInfo } from 'src/features/userSlice';

const ActiveDevice = ({ open, onClose, dataSelected }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const statusActive = useSelector(state => state.deviceSlice.statusActive);
  const username = useSelector(state => state.deviceSlice.username);
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const businessInfoRedux = useSelector(state => state.userSlice.businessInfo);
  const listAgencyBusiness = useSelector(
    state => state.agencySlice.listAgencyBusiness
  );
  const statusGet = useSelector(state => state.userSlice.statusGet);
  const [deviceTypeDetail, setDeviceTypeDetail] = useState({});
  const [selectedTonnage, setSelectedTonnage] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedPhone, setSelectedPhone] = useState('');
  const [businessInfo, setBusinessInfo] = useState(null);
  const [isTransmit, setIsTransmit] = useState(
    dataSelected.status_transmission || false
  );
  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    setBusinessInfo(businessInfoRedux);
  }, [isTransmit, statusGet, businessInfoRedux]);

  useEffect(() => {
    if (businessInfo && isTransmit) {
      setFormKey(prev => prev + 1);
    }
  }, [businessInfo, isTransmit]);

  const handleChangeSwitch = event => {
    const isTransmit = event.target.checked ? 1 : 0;
    if (isTransmit === 1 && selectedPhone) {
      dispatch(
        getBusinessInfo({
          phone: selectedPhone
        })
      );
    }
    dispatch(
      transmitActiveStatus({
        id: dataSelected.id,
        data: {
          status: isTransmit
        }
      })
    );
    setIsTransmit(event.target.checked);
  };

  const handleSubmit = data => {
    if (data && data.serial) {
      const dataActive = {
        phone: selectedPhone,
        full_name: username ? username : '',
        serial: data?.serial,
        version: data?.version,
        vehicle_license_plate:
          deviceTypeDetail?.id !== 1 ? data.vehicle_license_plate : null, // do tên người với biển số xe đang dùng chung 1 Textfield
        title_device_type: deviceTypeDetail?.name ? deviceTypeDetail.name : '',
        slots: data?.slots ? Number(data?.slots) : null,
        tonnage: data?.tonnage ? data?.tonnage : null,
        name_of_user_for_gps:
          deviceTypeDetail?.id === 1 ? data.vehicle_license_plate : null, // do tên người với biển số xe đang dùng chung 1 Textfield,
        business_id: isTransmit && data?.business_id ? data.business_id : null,
        passenger_capacity:
          isTransmit && data?.passenger_capacity
            ? Number(data.passenger_capacity)
            : null,
        tax_code: isTransmit && data?.tax_code ? data.tax_code : null,
        max_payload:
          isTransmit && data?.max_payload ? Number(data.max_payload) : null,
        transport_operator:
          isTransmit && data?.business_name ? data.business_name : null,
        sim_phone: data?.sim_phone ? data.sim_phone : null
      };
      dispatch(activeDevice(dataActive));
      handleClose();
    }
  };

  const handleClose = () => {
    dispatch(resetBusinessInfo());
    setBusinessInfo(null);
    setSelectedPhone('');
    setDeviceTypeDetail({});
    setSelectedTonnage([]);
    setSelectedSlots([]);
    setIsTransmit(dataSelected.status_transmission || false);
    setFormKey(prev => prev + 1);
    onClose();
  };

  const trim = x => {
    return x.replace(/^\(+|\)+$/gm, '');
  };

  const handleSelectVehicle = (e, value, setFieldValue) => {
    const target = vehicleType.find(type => {
      return type.id === Number(value.id);
    });
    if (target) {
      setFieldValue('title_device_type', target.name);
      setDeviceTypeDetail(target);
      setSelectedSlots(target?.slots);
      setSelectedTonnage(target?.tonnage);
    }
  };

  const handleChangePhoneNumber = (e, setFieldValue) => {
    let searchData = trim(e.target.value);
    setSelectedPhone(searchData);
    setFieldValue('phone', searchData);
    if (searchData && searchData.length === 10) {
      dispatch(getUsernameByPhoneNumber({ phoneNumber: searchData }));
      if (isTransmit) {
        dispatch(
          getBusinessInfo({
            phone: searchData
          })
        );
      }
    }
  };

  useEffect(() => {
    if (isAdmin) dispatch(getListAgencies());
    return () => {
      dispatch(resetSearchUsernameByPhone());
    };
  }, [dispatch]);

  return (
    <CustomDialog title="Kích hoạt thiết bị" open={open} onClose={handleClose}>
      <div>
        <Formik
          key={formKey}
          enableReinitialize={true}
          initialValues={{
            phone: selectedPhone ? selectedPhone : '',
            full_name: '',
            serial: dataSelected?.serial || '',
            title_device_type: '',
            vehicle_license_plate: '',
            version: dataSelected?.hardware_version || '',
            name_of_user_for_gps: '',
            tonnage: '',
            slots: '',
            device_type: dataSelected?.deviceType?.name || '',
            service_package:
              dataSelected?.deviceServicePackages?.servicePackage?.name || '',
            passenger_capacity: '',
            max_payload: '',
            tax_code: isTransmit ? businessInfo?.tax_code : '',
            business_id: isTransmit ? businessInfo?.business?.id : '',
            business_name: isTransmit ? businessInfo?.business_name : '',
            sim_phone: ''
          }}
          validationSchema={Yup.object().shape({
            vehicle_license_plate: Yup.string()
              .max(100)
              .matches(
                /^[A-Z0-9]+$/,
                'Chỉ nhập chữ in hoa và số, không chứa ký tự đặc biệt'
              )
              .required('Biển số không được để trống'),
            title_device_type: Yup.string().required(
              'Loại phương tiện không được để trống'
            ),
            phone: Yup.string()
              .matches(
                /^(84|0[3|5|7|8|9])+([0-9]{8})$/,
                'Số điện thoại chưa đúng định dạng'
              )
              .required('Số điện thoại không được để trống')
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tài khoản người dùng <span className="text-danger">*</span>
                  </InputLabel>
                  <TextField
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    error={Boolean(touched.phone && errors.phone)}
                    helperText={touched.phone && errors.phone}
                    margin="normal"
                    name="phone"
                    onBlur={handleBlur}
                    onChange={e => handleChangePhoneNumber(e, setFieldValue)}
                    value={values.phone}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tên người dùng <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    size="small"
                    disabled={true}
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="full_name"
                    onBlur={handleBlur}
                    value={username}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Serial thiết bị <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="serial"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.serial}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Loại thiết bị <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="serial"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.device_type}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Số điện thoại Sim <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="sim_phone"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.sim_phone}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel style={{ marginBottom: '21px' }}>
                    Loại phương tiện <span className="text-danger">*</span>
                  </InputLabel>
                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={vehicleType || []}
                    getOptionLabel={option => option.name}
                    value={(vehicleType || []).find(
                      option => option.name === values.title_device_type
                    )}
                    onChange={(e, value) =>
                      handleSelectVehicle(e, value, setFieldValue)
                    }
                    disableClearable
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn loại phương tiện"
                        name="title_device_type"
                        error={Boolean(
                          touched.title_device_type && errors.title_device_type
                        )}
                        helperText={
                          touched.title_device_type && errors.title_device_type
                        }
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px'
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    {deviceTypeDetail?.id !== 1 ? 'Biển số xe' : 'Tên người'}
                    <span className="text-danger"> *</span>
                  </InputLabel>
                  <TextField
                    size="small"
                    className="input-no-fieldset"
                    error={Boolean(
                      touched.vehicle_license_plate &&
                        errors.vehicle_license_plate
                    )}
                    fullWidth
                    helperText={
                      touched.vehicle_license_plate &&
                      errors.vehicle_license_plate
                    }
                    margin="normal"
                    name="vehicle_license_plate"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.vehicle_license_plate}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Phiên bản <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="version"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.version}
                    variant="outlined"
                  />
                </Grid>
                {deviceTypeDetail.id === 6 && (
                  <Grid item md={6} xs={12}>
                    <InputLabel>
                      Tải trọng <span className="text-danger">*</span>
                    </InputLabel>
                    <TextField
                      className="input-no-fieldset"
                      size="small"
                      fullWidth
                      select
                      margin="normal"
                      name="tonnage"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      SelectProps={{
                        native: true
                      }}
                      value={values.tonnage}
                      variant="outlined"
                    >
                      <option>Chọn loại tải trọng</option>
                      {selectedTonnage &&
                        selectedTonnage.map(type => (
                          <option key={type.id} value={type.value}>
                            {type.name}
                          </option>
                        ))}
                    </TextField>
                  </Grid>
                )}

                {deviceTypeDetail.id === 4 && (
                  <Grid item md={6} xs={12}>
                    <InputLabel>
                      Số chỗ <span className="text-danger">*</span>
                    </InputLabel>
                    <TextField
                      className="input-no-fieldset"
                      size="small"
                      fullWidth
                      select
                      margin="normal"
                      name="slots"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      SelectProps={{
                        native: true
                      }}
                      value={values.slots}
                      variant="outlined"
                    >
                      <option>Chọn số chỗ</option>
                      {selectedSlots &&
                        selectedSlots.map(type => (
                          <option key={type.id} value={type.value}>
                            {type.name}
                          </option>
                        ))}
                    </TextField>
                  </Grid>
                )}

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Gói dịch vụ <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="service_package"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.service_package || '365D'}
                    variant="outlined"
                  />
                </Grid>

                {isTransmit && (
                  <>
                    <Grid item md={6} xs={12}>
                      <InputLabel>
                        Tên doanh nghiệp <span className="text-danger"></span>
                      </InputLabel>
                      <TextField
                        size="small"
                        className="input-no-fieldset"
                        fullWidth
                        margin="normal"
                        name="business_name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.business_name || ''}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <InputLabel>
                        Mã số thuế<span className="text-danger"></span>
                      </InputLabel>
                      <TextField
                        size="small"
                        className="input-no-fieldset"
                        fullWidth
                        margin="normal"
                        name="tax_code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.tax_code || ''}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <InputLabel style={{ marginBottom: '21px' }}>
                        Loại hình kinh doanh{' '}
                        <span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <Autocomplete
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        size="small"
                        options={listAgencyBusiness || []}
                        getOptionLabel={option => option.title}
                        value={(listAgencyBusiness || []).find(
                          option => Number(option.id) === Number(values.business_id)
                        )}
                        onChange={(e, value) =>
                          setFieldValue('business_id', value.id)
                        }
                        disableClearable
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Chọn loại hình kinh doanh"
                            name="business_id"
                            error={Boolean(
                              touched.business_id && errors.business_id
                            )}
                            helperText={
                              touched.business_id && errors.business_id
                            }
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                fontSize: '16px',
                                padding: '0 8px',
                                height: '35px'
                              }
                            }}
                          />
                        )}
                        className={classes.customOutline}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <InputLabel>
                        Số lượng chỗ đăng ký kinh doanh{' '}
                        <span className="text-danger"></span>
                      </InputLabel>
                      <TextField
                        size="small"
                        className="input-no-fieldset"
                        fullWidth
                        margin="normal"
                        name="passenger_capacity"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.passenger_capacity || ''}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <InputLabel>
                        Tải trọng đăng ký kinh doanh{' '}
                        <span className="text-danger"></span>
                      </InputLabel>
                      <TextField
                        size="small"
                        className="input-no-fieldset"
                        fullWidth
                        margin="normal"
                        name="max_payload"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.max_payload || ''}
                        variant="outlined"
                      />
                    </Grid>
                  </>
                )}
              </Grid>
              <Box my={3}>
                <div className={classes.groupButtonSubmit}>
                  <div className={classes.buttonGroup}>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 90 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      onClick={handleClose}
                      className="btn-main btn-plain mx-3"
                      color="primary"
                      size="large"
                      variant="contained"
                    >
                      Thoát
                    </Button>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 120 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      className="btn-main mx-3"
                      color="primary"
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Kích hoạt
                    </Button>
                  </div>
                  <Box className={classes.switchContainer}>
                    <InputLabel className={classes.switchLabel}>
                      Tích truyền QCVN BCA <span className="text-danger"></span>
                    </InputLabel>
                    <Switch
                      checked={isTransmit}
                      onChange={handleChangeSwitch}
                      name="isTransmit"
                      inputProps={{ 'aria-label': 'secondary checkbox' }}
                    />
                  </Box>
                  {statusActive === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',
    position: 'relative'
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    }
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 0
  },
  switchLabel: {
    marginRight: '10px',
    marginBottom: '0 !important',
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)'
  }
}));

export default React.memo(ActiveDevice);
